import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-phone-inprocess-script-redirection.component.ajs.html';

const MODULE_NAME = 'agentBookingPhoneInprocessScriptRedirection';

class AgentBookingPhoneInprocessScriptRedirectionCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingPhoneInprocessScriptRedirection implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingPhoneInprocessScriptRedirectionCtrl];
}

export default MODULE_NAME;
